import { HANDLE_NEW_QDD } from '../actions/sync';
import objectByID from './objectByID';

const options = (state = [], action) => {
  switch(action.type) {
    case 'CREATE_OPTION':
      var option = Object.assign({updatedAt: (new Date()).getTime(), id: action.id}, action.props);
      return [...state, option];
    case 'UPDATE_OPTION':
      var option = objectByID(state, action.id);
      var index = state.indexOf(option);
      return [
        ...state.slice(0, index),
        Object.assign({}, option, action.props, {updatedAt: (new Date()).getTime()}),
        ...state.slice(index+1)
      ];
    case 'DELETE_OPTION':
      var option = objectByID(state, action.id);
      var index = state.indexOf(option);
      return [
        ...state.slice(0, index),
        ...state.slice(index+1)
      ];
    case 'DELETE_CATEGORY':
      return state.map((option) => {
        if (option.category === action.id) {
          return {
            ...option,
            category: action.reassignmentCategoryID
          }
        } else {
          return option;
        }
      });
    case HANDLE_NEW_QDD:
      return action.payload.targets;
    default:
      return state;
  }
}

export default options;

export const getAllOptions = (state) => state

export const optionByID = objectByID

export const sortedOptions = (state) =>
  state.slice().sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()))

export const optionsBySectionAndCategory = (state, categories) => {
  // let sorted = sortedOptions(state);
  //state is being passed state.options from reducer index, not the entire state
  let sections = {monitoring: [], assessment: [], controlRules: []};
  state.forEach((option) => {
    if (!sections[option.section][option.category]) {
      sections[option.section][option.category] = [option];
    } else {
      sections[option.section][option.category].push(option);
    }
  });
  // now, change from key-based section organization to just a flat array
  return Object.keys(sections).map((key) => {
    return {
      title: key,
      categories: Object.keys(sections[key]).map((categoryID) => {
        let category = objectByID(categories, parseInt(categoryID));
        return {
          ...category,
          options: sections[key][categoryID]
        };
      }).sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()))
    }
  });
}
